import 'css-chunksrc/client/scenes/assignToTask/projectSelection/section/styles.scss';export default {
  "header": "_header_1she0_1",
  "iconBox": "_iconBox_1she0_10",
  "icon": "_icon_1she0_10",
  "open": "_open_1she0_28"
};